const {createSlice} = require('@reduxjs/toolkit');

/**
 * The exchange lens, shared by Multi Asset and Trading View.
 *
 * Deliberately a lens rather than a route hierarchy: an ops person triaging
 * orders has to be able to see every venue at once, and the backend takes a
 * list of exchange ids rather than nesting under one. `null` means All markets.
 *
 * Persisted so switching between the two sections keeps the venue you were
 * looking at; the URL carries it too, so links stay shareable.
 */
const slice = createSlice({
  name: 'exchangeScope',
  initialState: {
    exchangeId: null,
  },
  reducers: {
    setExchangeScope: (state, action) => {
      state.exchangeId = action.payload || null;
    },
  },
});

export default slice.reducer;
export const {setExchangeScope} = slice.actions;
